/** Whether `useBlocker` should stop in-app navigation for unsaved edit pages. */
export function shouldBlockUnsavedNavigation({
  allowLeave,
  bypass = false,
  hasUnsavedChanges,
  currentPathname,
  nextPathname,
}: {
  allowLeave: boolean
  bypass?: boolean
  hasUnsavedChanges: boolean
  currentPathname: string
  nextPathname: string
}): boolean {
  if (allowLeave || bypass) return false
  if (!hasUnsavedChanges) return false
  return currentPathname !== nextPathname
}
